import script from "./MinifigurElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./MinifigurElement.vue?vue&type=script&setup=true&lang=ts"

export default script